import { render, staticRenderFns } from "./EmMenuList.vue?vue&type=template&id=5631c7e3&"
import script from "./EmMenuList.vue?vue&type=script&lang=js&"
export * from "./EmMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports